import { render, staticRenderFns } from "./TareaUsuarioFormComponent.vue?vue&type=template&id=f28ffcc2&"
import script from "./TareaUsuarioFormComponent.vue?vue&type=script&lang=js&"
export * from "./TareaUsuarioFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports